import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-information-product',
  templateUrl: './information-product.component.html',
  styleUrls: ['./information-product.component.scss'],
})
export class InformationProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
